/**
 * Maps SaveFilterModal submit slice → API date fields for saved stats filters.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { CreateSavedFilterPayload } from '@/features/smswiser-campaigns/types/saved-filter.types';

export type SaveFilterDateSubmitSlice = {
  dateRangePreset: string | null;
  includeFixedDateRange: boolean;
  dateFrom: string | null;
  dateTo: string | null;
  dateToUntilToday: boolean;
};

export function buildSavedFilterDatePayload(
  data: SaveFilterDateSubmitSlice,
): Pick<
  CreateSavedFilterPayload,
  'dateRangePreset' | 'dateFrom' | 'dateTo' | 'dateToUntilToday'
> {
  if (data.dateRangePreset) {
    return {
      dateRangePreset: data.dateRangePreset,
      dateFrom: null,
      dateTo: null,
      dateToUntilToday: false,
    };
  }
  if (!data.includeFixedDateRange) {
    return {
      dateRangePreset: null,
      dateFrom: null,
      dateTo: null,
      dateToUntilToday: false,
    };
  }
  if (data.dateToUntilToday) {
    return {
      dateRangePreset: null,
      dateFrom: data.dateFrom,
      dateTo: null,
      dateToUntilToday: true,
    };
  }
  return {
    dateRangePreset: null,
    dateFrom: data.dateFrom,
    dateTo: data.dateTo,
    dateToUntilToday: false,
  };
}
